import React from "react";
import login from "../../api.js";
import "./components/style.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useContext } from "react";

export default function Login() {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState(""); // 🔴 Error state
  const navigate = useNavigate();
  const [showForgotBox, setShowForgotBox] = React.useState(false);

  const { authenticate } = useContext(AuthContext);

  async function checkCredentials(e) {
    e.preventDefault();

    try {
      const result = await login(username, password);

      if (result.success) {
        localStorage.setItem("userData", JSON.stringify(result.userData));
        await authenticate();
        navigate("/dashboard");
      } else {
        setError("Usuario o contraseña incorrectos."); // 🔴 Show error
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("An error occurred during login."); // 🔴 Show error
    }
  }

  return (
    <div className="loginContainer">
      <div className="signinContainer">
        <h1 className="signinTitle">Iniciar sesión</h1>

        {/* 🔴 Error message */}
        {error && <p style={{ color: "red", marginBottom: "1rem" }}>{error}</p>}

        <form onSubmit={checkCredentials} className="signinForm">
          <p>
            <label htmlFor="username" className="formLabel">
              Usuario
            </label>
          </p>
          <input
            type="text"
            id="username"
            className="formInput"
            placeholder="Usuario"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <p>
            <label htmlFor="password" className="formLabel">
              Contraseña
            </label>
          </p>
          <input
            type="password"
            id="password"
            className="formInput"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <p
            className="forgotPassword"
            onClick={() => setShowForgotBox(true)}
            style={{ cursor: "pointer", color: "#007bff" }}
          >
            ¿Olvidé la contraseña?
          </p>

          <button type="submit" className="login-button">
            Iniciar sesión
          </button>
        </form>
        {showForgotBox && (
          <div
            style={{
              backgroundColor: "#ffdddd",
              color: "#b30000",
              padding: "1rem",
              marginTop: "1rem",
              borderRadius: "6px",
              border: "1px solid #ffaaaa",
            }}
          >
            Escríbale a Esteban Muñoz.
          </div>
        )}
      </div>

      {/* 🔵 Do not touch this */}
      <div className="logoContainer">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <img
            src="./logoIglesiaWhite.svg"
            alt="logo"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}
